"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchCityRequest = void 0;
var SearchCityRequest = /** @class */ (function () {
    function SearchCityRequest() {
    }
    return SearchCityRequest;
}());
exports.SearchCityRequest = SearchCityRequest;
;
//# sourceMappingURL=searchCity.request.js.map